import { FC } from 'react';

import { ErrorPageLazy } from './ErrorPage.lazy';

interface Props {
  customStatusCode?: number;
}

export const ErrorPage: FC<Props> = ({ customStatusCode }) => {
  return <ErrorPageLazy customStatusCode={customStatusCode} />;
};
